import { Box, Card, CardContent, Paper, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import Api from '../../../Apis/api.service'
import CardTicket from './CardTicket'
import { middleofficeRequest } from '../../../axios'
import CardNews from './CardNews'

export const Dashboard = ({ copro, coproprietaire_id, ...props }) => {
  const [lastThreeTickets, setLastThreeTickets] = useState([])
  const [lastThreeNews, setLastThreeNews] = useState([])

  const fetchData = () => {
    getListTickets()
    getLastNews()
  }

  const getListTickets = async () => {
    const res = await Api.coproprietaires.getTicketsCoproprietaire(
      coproprietaire_id
    )
    if (res.status == 200 && res.data.ok) {
      if (!res.data.data || res.data.data.length === 0) {
        const noTicket = [
          {
            libelle: 'Aucune intervention en cours',
          },
        ]
        setLastThreeTickets(noTicket)
      } else {
        setLastThreeTickets(res.data.data)
      }
    } else {
      console.log(res.data.message)
    }
  }

  const getLastNews = async () => {
    try {
      const res = await middleofficeRequest.get(`middleoffice/news`, {
        params: { coproId: copro.copro_internal_id },
      })

      if (!res.data || res.data.length === 0) {
        const noNews = [
          {
            description: 'Aucune Actualité pour le moment',
          },
        ]
        setLastThreeNews(noNews)
      } else {
        setLastThreeNews(res.data.slice(0, 3))
      }
    } catch (error) {
      return []
    }
  }

  useEffect(() => {
    fetchData()
  }, [])
  return (
    <>
      <Box
        component={Paper}
        padding={'30px 60px'}
        sx={{ minHeight: 200, background: '#e7ebf0' }}
      >
        <Typography variant="h5">
          Les 3 dernières Actualités pour votre copropriété
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            gridColumnGap: '60px',
            marginTop: '20px',
          }}
        >
          {lastThreeNews.map((newsData) => {
            return <CardNews key={newsData.id} newsData={newsData} />
          })}
        </Box>{' '}
        <Typography variant="h5" style={{ marginTop: '30px' }}>
          Vos 3 dernières interventions en cours
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            flexWrap: 'wrap',
            gridColumnGap: '60px',
            marginTop: '20px',
          }}
        >
          {lastThreeTickets.map((ticket, index) => {
            return <CardTicket key={index} ticket={ticket} />
          })}
        </Box>
      </Box>
    </>
  )
}
export default Dashboard
